import { useState } from 'react';
import type { Board, TaskStatus } from '../../types';
import { useApp } from '../../context/AppContext';
import { generateId } from '../../utils/helpers';
import KanbanColumn from './KanbanColumn';
import NewTaskForm from './NewTaskForm';

interface KanbanBoardProps {
  board: Board;
}

export default function KanbanBoard({ board }: KanbanBoardProps) {
  const { getTasksForBoard } = useApp();
  const [newTaskStatus, setNewTaskStatus] = useState<TaskStatus | null>(null);
  const tasks = getTasksForBoard(board.id);

  const handleAddTask = (status: TaskStatus) => {
    setNewTaskStatus(status);
  };

  return (
    <>
      <div className="kanban-scroll flex gap-4 p-4 md:p-6 h-full">
        {board.columns.map((column) => {
          const columnTasks = tasks.filter((t) => t.status === column.status);
          return (
            <KanbanColumn
              key={column.id}
              column={column}
              tasks={columnTasks}
              onAddTask={handleAddTask}
            />
          );
        })}
      </div>

      {newTaskStatus && (
        <NewTaskForm
          boardId={board.id}
          initialStatus={newTaskStatus}
          onClose={() => setNewTaskStatus(null)}
        />
      )}
    </>
  );
}

export function QuickTaskId() {
  return `task-${generateId()}`;
}
